import { useState, useRef } from "react";
import { Box, IconButton, Button, Image } from "@chakra-ui/react";

import AlertDialogModel from "./AlertDialogModel";
import resetIcon from "../../assets/waveflowmain/reset_icon.png";
import { useSelector } from "react-redux";

const ResetButton = ({ resetFlowHandle, isOpen, setIsOpen }) => {
  const onClose = () => setIsOpen(false);
  const waveflowResetLoder = useSelector(
    (state) => state.waveflowSearchData.resetLoading
  );

  const propData = {
    title: "Confirm Reset",
    description: "Are you sure you want to Reset workflow?",
    btnName: "Reset",
    isOpen: isOpen,
    onClose: onClose,
    handleForAction: resetFlowHandle,
    waveflowResetLoder:waveflowResetLoder
  };

  return (
    <>
      <IconButton
        draggable="false"
        aria-label="Profile"
        icon={<Image draggable={false} src={resetIcon} w={"20px"} />}
        // onClick={resetFlowHandle}
        bg={"transparent"}
        _hover={{
          bg: "transparent",
        }}
        onClick={() => setIsOpen(true)}
      />

      <AlertDialogModel {...propData} />
    </>
  );
};

export default ResetButton;
